import { z } from 'zod';
import { ZodArrayToEnum } from '@axiom/types';

import { CandidateOpportunitySchema } from './candidate-opportunities';
import { AfcSubmissionCandidateSchema } from './afc-submission-candidate';
import { ZodCandidateOpportunityCandidateStatuses } from './candidate-opportunities-candidate-statuses';

export const AfcSubmissionCandidateOpportunityBadges = [
  'Axiom Pick',
  'Top Match',
  'Self-Submitted',
] as const;

export const AfcSubmissionCandidateOpportunitySchema =
  CandidateOpportunitySchema.pick({
    candidateReputationClarification: true,
    displayBillingRate: true,
    id: true,
    pinnedByClient: true,
    proposedHourlyRate: true,
    nonDiscountedRate: true,
    showCandidateReputation: true,
  }).extend({
    badge: z
      .enum(
        ZodArrayToEnum(Object.values(AfcSubmissionCandidateOpportunityBadges))
      )
      .nullable(),
    candidate: AfcSubmissionCandidateSchema,
    candidateStatus: ZodCandidateOpportunityCandidateStatuses.nullable(),
    interviewRequested: z.boolean().nullable(),
    isInstantMatch: z.boolean().default(false), // Bad Prop APCORE-2591
    submissionDescription: z.string().nullable(),
  });

export type AfcSubmissionCandidateOpportunity = z.infer<
  typeof AfcSubmissionCandidateOpportunitySchema
>;
